import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("学習データの追加")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "flex flex-col items-center w-full mx-auto" }
const _hoisted_4 = { class: "flex w-3/4 mx-auto mb-6" }
const _hoisted_5 = { class: "mx-2 w-full" }
const _hoisted_6 = { class: "mx-2 w-full" }
const _hoisted_7 = { class: "flex w-3/4 mx-auto mb-6" }
const _hoisted_8 = { class: "mx-2 w-full" }
const _hoisted_9 = { class: "mx-2 w-full" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "mb-2 text-red-500 text-xs" }, " ※ 学習開始日時には学習終了日時より未来の日時を入力してください ", -1)
const _hoisted_12 = { class: "flex flex-col items-center w-3/4 mx-auto" }
const _hoisted_13 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 学習データを追加 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_subjects_input = _resolveComponent("m-subjects-input")
  const _component_m_select_box = _resolveComponent("m-select-box")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "目標",
          goal: "goal",
          type: "text",
          placeholder: "目標を記入",
          value: _ctx.goal,
          entered: "",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goal = $event))
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_m_text_field, {
              label: "学習開始日",
              name: "day",
              type: "date",
              placeholder: "2020/11/22",
              value: _ctx.startDate,
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startDate = $event))
            }, null, 8, ["value"])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_m_text_field, {
              label: "学習開始時間",
              name: "time",
              type: "time",
              placeholder: "18:00",
              value: _ctx.startTime,
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.startTime = $event))
            }, null, 8, ["value"])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_m_text_field, {
              label: "学習終了日",
              name: "day",
              type: "date",
              placeholder: "2020/11/22",
              value: _ctx.endDate,
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.endDate = $event))
            }, null, 8, ["value"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_m_text_field, {
              label: "学習終了時間",
              name: "time",
              type: "time",
              placeholder: "18:00",
              value: _ctx.endTime,
              onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.endTime = $event))
            }, null, 8, ["value"])
          ])
        ]),
        (!_ctx.validRecord)
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _hoisted_11
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_m_subjects_input, {
          class: "mb-6",
          subjects: _ctx.subjects,
          grade: _ctx.student.data.grade,
          onSelect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeSubjects($event)))
        }, null, 8, ["subjects", "grade"])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode(_component_m_select_box, {
          key: "ref.id",
          label: "ラベル",
          name: "label",
          placeholder: "ラベルを選択",
          options: _ctx.labels,
          value: _ctx.selectedLabelId,
          "value-key": "ref.id",
          "text-key": "data.name",
          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedLabelId = $event))
        }, null, 8, ["options", "value"])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.addLearningData
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}